import { useState,useEffect } from 'react';
import './MailerLite.css';

// Import the background image
import backgroundImage from './woodgrain.png';  // Adjust the path based on your file structure

const MailerLite = () => {
  const [subscriptionStatus, setSubscriptionStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const subscribeUser = async (email) => {
    setIsLoading(true);
    try {
      const response = await fetch('https://connect.mailerlite.com/api/subscribers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_MAILERLITE_API_KEY}`,
        },
        body: JSON.stringify({
          email: email.get('email'),
          status: "unconfirmed",
          groups: ["136114632182990219"],
        })
      });

      // Log the response for debugging
      console.log('Response status:', response.status);
      
      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok) {
        setSubscriptionStatus('Successfully subscribed!');
        document.getElementById('subscription-form').reset();
      } else {
        setSubscriptionStatus(`Error: ${data.message || 'Failed to subscribe'}`);
      }
    } catch (error) {
      console.error('Detailed error:', error);
      setSubscriptionStatus('Error subscribing user');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="newsletter" class="newsletter">
    <div className="newsletter-content">
      <div class="newsletter-text">Subscribe to our mailing list for an exclusive look at the first chapter. 
        Be the first to hear about all new releases, special offers, and upcoming events!</div>

      <div className ="newsletter-form">
      <form
        id="subscription-form"
        onSubmit={(e) => {
          e.preventDefault();
          const data = new FormData(e.target);
          console.log(data);
          subscribeUser(data);
        }}
        className="subscription-form"
      >
        <div className="newsletter-field">

          {/* <label htmlFor="email" className="subscription-form__label">
            Email
          </label> */}
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Enter your email"
            required
            className="subscription-form__input"
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className={`subscription-form__button ${isLoading ? 'disabled' : ''}`}
        >
          {isLoading ? 'Signing up...' : 'Sign up'}
          <input type="hidden" name="status" value="unconfirmed" />
        </button>
      </form>
      {subscriptionStatus && (
        <p
          className={`subscription-form__status ${subscriptionStatus.includes('Error') ? 'error' : 'success'
            }`}
        >
          {subscriptionStatus}
        </p>
      )}
      </div>
    </div>
    </section>
  );
};

export default MailerLite;